export const UNDERLINE_COLOR = "underlineColor"
